import chineseTWMessages from 'ra-language-chinese-traditional';
import adminTranslations from './admin';

const Translation = {
  ...chineseTWMessages,
  ...adminTranslations,
  ra: {
    ...chineseTWMessages.ra,
    page: {
      ...chineseTWMessages.ra.page,
      empty: "沒有記錄",
      general: "一般資料",
      invite: "",
      simple_acl: "權限管理",
    },
    message: {
      ...chineseTWMessages.ra.message,
      error: "錯誤",
    },
    action: {
      ...chineseTWMessages.ra.action,
      unselect: "取消選擇",
      clone: "複製",
      confirm: "確定",
      search_copy: "搜尋並複製",
      clear_input_value: "清除",
      import_csv: "滙入CSV",
      next: "下一步",
      upload: "上載",
      html_editor: "HTML 編輯器",
      file_manager: "文件助理",
      links_manager: "連結助理",
      qr_code_generator: "QR Code 生成",
      close: "關閉",
    },
    navigation: {
      ...chineseTWMessages.ra.navigation,
      skip_nav: "跳過"
    }
  },
  undefined: "undefined",
  null: "null",
  myroot: {
    notify: {
      auth: {
        sendActivationEmail: "AAA",
        passwordRegen: "New Password: %{newPassword}",
        changePassword: {
          success: "New password applied.",
          fail: "Change Password failed."
        }
      },
      recordExtra: {
        lock: "%{recordCaption} has be locked",
        unlock: "%{recordCaption} has be unlocked",
        active: "%{recordCaption} is now active",
        deactive: "%{recordCaption} is now deactive"
      }
    }
  },
  menu: {
    user: "帳戶",
    saleables: "銷售品",
    crm: "客戶關係",
    misc: "其他",
    maintenance: "保養相關",
    my_profile: "我的帳戶"
  },
  __: "END"
}

export default Translation;
